function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 0C5 0 0 5 0 11c0 7.2 7.2 10.7 8 11.5 1 1 2 2.5 3 4.5 1-2 2-3.6 3-4.5.8-.8 8-4.3 8-11.5 0-6-5-11-11-11Z",
  fill: "#FFD338",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#000",
  fillRule: "nonzero",
  x: 5,
  y: 9,
  width: 12,
  height: 10,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 7a3 3 0 1 1 6 0v2c0 .6-.4 1-1 1H9a1 1 0 0 1-1-1V7Z",
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFD338",
  fillRule: "nonzero",
  cx: 11,
  cy: 14,
  r: 1
}));

function SvgFunnelBlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 27",
    width: 22,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelBlocked);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyNyIgd2lkdGg9IjIyIiBoZWlnaHQ9IjI3Ij48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0xMSAwQzUgMCAwIDUgMCAxMWMwIDcuMiA3LjIgMTAuNyA4IDExLjUgMSAxIDIgMi41IDMgNC41IDEtMiAyLTMuNiAzLTQuNS44LS44IDgtNC4zIDgtMTEuNSAwLTYtNS0xMS0xMS0xMVoiIGZpbGw9IiNGRkQzMzgiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxyZWN0IGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgeD0iNSIgeT0iOSIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEwIiByeD0iMiIvPjxwYXRoIGQ9Ik04IDdhMyAzIDAgMSAxIDYgMHYyYzAgLjYtLjQgMS0xIDFIOWExIDEgMCAwIDEtMS0xVjdaIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIvPjxjaXJjbGUgZmlsbD0iI0ZGRDMzOCIgZmlsbC1ydWxlPSJub256ZXJvIiBjeD0iMTEiIGN5PSIxNCIgcj0iMSIvPjwvZz48L3N2Zz4K";
export { ForwardRef as ReactComponent };